import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {ConfigProvider} from "antd";
import ptBr from 'antd/lib/locale-provider/pt_BR';
import moment from 'moment';
import 'moment/locale/pt-br';
import {Provider} from "react-redux";
import store from "./store";

moment.locale('pt-br');

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={ptBr}>
      <App/>
    </ConfigProvider>
  </Provider>,
  document.getElementById('root'));

// window.addEventListener("beforeunload", function (e) {
//     const confirmationMessage = '\o/';
//
//     e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
//     return confirmationMessage;              // Gecko, WebKit, Chrome <34
// });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// serviceWorker.register();
